module.exports = __webpack_public_path__ + "static/media/favorites.dc10e543.svg";